import styled from 'styled-components';
import Parent from './style';

const Wrapper = styled(Parent.Wrapper)`
position: relative;
.CSAForms .vertical-button .MuiButtonBase-root {
    margin-top: 33px;
}
`;
const TopWrapper = styled(Parent.TopWrapper)`
 
`;
const TableWrapper = styled(Parent.TableWrapper)`
${({ theme }) => `
.MuiTableCell-sizeSmall:last-child {
    text-align: center;
    justify-content: center !important;
    display: flex;
    align-items: center !important;
}
.MuiTableCell-head:last-child {
    text-align: center !important;
    justify-content: center !important;
    display: flex;
    align-items: center !important;
  }
`}
`;
const Styled = { Wrapper, TopWrapper, TableWrapper };

export default Styled;
